import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// pages
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Media from "./pages/Media";
import ContactUS from "./pages/ContactUS";
function Router() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contactus" element={<ContactUS />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default Router;
